import { Modal, Table } from "react-bootstrap";

const LineItemsModal = ({ showModal, setShowModal, selectedOrder }) => {
return (
<Modal 
show={showModal} 
onHide={() => setShowModal(false)} 
size="lg"
centered
>
<Modal.Header closeButton>
  <Modal.Title>
    {selectedOrder ? (
      <span>Order #{selectedOrder.order_id} - Line Items</span>
    ) : (
      "Order Details"
    )}
  </Modal.Title>
</Modal.Header>
<Modal.Body>
  {selectedOrder && selectedOrder.lineItemsArray && (
    <div>
      <div className="mb-3">
        <strong>Customer:</strong> {selectedOrder.customerName}<br />
        <strong>Order Date:</strong> {selectedOrder.formattedDate}<br />
        <strong>Status:</strong> {selectedOrder.status}<br />
        <strong>Total:</strong> {selectedOrder.currency_symbol}{selectedOrder.total}
      </div>
      
      <h5>Line Items</h5>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Product</th>
            <th>SKU</th>
            <th>Quantity</th>
            <th>Price</th>
            <th>Total</th>
            <th>Metadata</th>
          </tr>
        </thead>
        <tbody>
          {selectedOrder.lineItemsArray.map((item, index) => (
            <tr key={index}>
              <td>
                {item.image && (
                  <img 
                    src={item.image.src} 
                    alt={item.name} 
                    style={{ width: '50px', marginRight: '10px' }} 
                  />
                )}
                <div>
                  <strong>{item.name}</strong>
                  {item.parent_name && item.parent_name !== item.name && (
                    <div><small>Parent: {item.parent_name}</small></div>
                  )}
                </div>
              </td>
              <td>{item.sku}</td>
              <td>{item.quantity}</td>
              <td>{selectedOrder.currency_symbol}{parseFloat(item.price).toFixed(2)}</td>
              <td>{selectedOrder.currency_symbol}{parseFloat(item.total).toFixed(2)}</td>
              <td>
                {item.meta_data && item.meta_data.length > 0 ? (
                  <Table size="sm" borderless>
                    <tbody>
                      {item.meta_data.map((meta, metaIndex) => (
                        <tr key={metaIndex}>
                          <td><strong>{meta.display_key}:</strong></td>
                          <td>{meta.display_value}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <span className="text-muted">No metadata</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="4" className="text-end"><strong>Subtotal:</strong></td>
            <td colSpan="2">
              {selectedOrder.currency_symbol}
              {selectedOrder.lineItemsArray.reduce((sum, item) => sum + parseFloat(item.subtotal), 0).toFixed(2)}
            </td>
          </tr>
          {parseFloat(selectedOrder.discount_total) > 0 && (
            <tr>
              <td colSpan="4" className="text-end"><strong>Discount:</strong></td>
              <td colSpan="2">{selectedOrder.currency_symbol}{selectedOrder.discount_total}</td>
            </tr>
          )}
          {parseFloat(selectedOrder.shipping_total) > 0 && (
            <tr>
              <td colSpan="4" className="text-end"><strong>Shipping:</strong></td>
              <td colSpan="2">{selectedOrder.currency_symbol}{selectedOrder.shipping_total}</td>
            </tr>
          )}
          {parseFloat(selectedOrder.total_tax) > 0 && (
            <tr>
              <td colSpan="4" className="text-end"><strong>Tax:</strong></td>
              <td colSpan="2">{selectedOrder.currency_symbol}{selectedOrder.total_tax}</td>
            </tr>
          )}
          <tr>
            <td colSpan="4" className="text-end"><strong>Total:</strong></td>
            <td colSpan="2">{selectedOrder.currency_symbol}{selectedOrder.total}</td>
          </tr>
        </tfoot>
      </Table>
      
      {selectedOrder.shipping_lines && selectedOrder.shipping_lines.length > 0 && (
        <div className="mt-4">
          <h5>Shipping Method</h5>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Method</th>
                <th>Cost</th>
              </tr>
            </thead>
            <tbody>
              {selectedOrder.shipping_lines.map((shipping, index) => (
                <tr key={index}>
                  <td>{shipping.method_title}</td>
                  <td>{selectedOrder.currency_symbol}{parseFloat(shipping.total).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  )}
</Modal.Body>
<Modal.Footer>
  <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
    Close
  </button>
</Modal.Footer>
</Modal>
);  
}

export default LineItemsModal;
